
<!-- Section Container -->

<div class="spacer"></div>

<div class="content-container">

  <div class="content-sub">

    <div class="c-sec-left">

      <div class="bg-dv">

        <h1>11+ Summer Intensive Course 2025 <br>19 Jul - 07 Sep</h1>

        <p>An 11+ summer intensive course is a focused, short-term educational program designed to prepare students for the 11+ entrance exams, which are used for admission into grammar and selective independent schools in the UK. This course will be held during the summer holidays Sat 19 Jul to Sun 7 Sep and is intended to give students a final boost before the exams in September. <br> <br>

          This programme offers a complete, structured approach to 11+ preparation with subject-specific learning, practice, mock testing, and personalised feedback. <br> <br>
          
          <Strong class="lm-space">LIMITED SPACES, REGISTER ASAP TO SECURE A PLACE.</Strong></p>

          <ul>
            <li class="course-ft"> <img src="assets/images/rapid-1.png" alt=""> <strong>  Category:</strong> 11plus Rapid Course</li>

            <li class="course-ft"> <img src="assets/images/rapid-2.png" alt=""> <strong>  For:</strong> 11plus</li>
  
            <li class="course-ft"> <img src="assets/images/rapid-3.png" alt=""> <strong>  Type:</strong> CSSE, GL, FSCE, SET</li>
  
            <li class="course-ft"> <img src="assets/images/rapid-4.png" alt=""> <strong>  Year Applicable:</strong> Year 5</li>

            <li class="course-ft"> <img src="assets/images/rapid-5.png" alt=""> <strong>  Seats Available:</strong> Yes</li>
          </ul>


      </div>


    </div>

    <div class="c-sec-right">

      <div class="cs-right-sub">

        <img src="assets/images/rapid-course-bg.png" alt="">

        <div class="cont-price">

          <div>
            <h2>£99.00</h2>
            Registration Fee 

          </div>
          

          <button class="tag-online">Mode: Online</button>
        </div>

        <ul class="course-ft-list">

          <li class="course-ft">
            <div class="strike-container">
              <strong>Full Course Fee: </strong>
              <span class="strike-price">£1485.96</span>
            </div>
          </li>

          <li class="course-ft"> <strong style="color: rgb(20, 139, 20);"> Early Bird Price: <strong style="color: #ED6823;">£1238.30</strong><br> <span style="font-size: 16px;">(Expires end of May)</span></strong> </li>

          <!-- <li class="course-ft"> <strong> Full Course Fee: <strong style="color: #ED6823;"> £1485.96</strong></strong> </li> -->

          
          
        </ul>

        <div class="button-cont"> 
          <Strong>Registration Fee Will be adjusted in the course fee. </Strong> 
          <button class="book-btn" (click)="bookSlot()">Book a Slot</button>

          <Strong>Last Booking Date: 31/07/2025 </Strong>
          
         
        </div>


      </div>
      
    </div>


  </div>
</div>


<div class="ss-timing">

  <h1 class="hdings">Session Timings</h1>

  <div class="st-cont">

    <div class="st-card">

      <p>Availability</p>

      <ul>
        <li class="st-li"> <img src="assets/images/rapid-7.png" alt=""> <strong>  From:</strong>  July 19, 2025</li>
      </ul>

    </div>

    <div class="st-card">

      <p>Availability</p>

      <ul>
        <li class="st-li"> <img src="assets/images/rapid-7.png" alt=""> <strong>  To:</strong>  Sep 09, 2025</li>
      </ul>

    </div>


    <div class="st-card">

      <p>Duration</p>

      <ul>
        <li class="st-li"> <img src="assets/images/rapid-8.png" alt=""> <strong>  7 Weeks</strong></li>
      </ul>

    </div>


  </div>
</div>




<!-- Pricing Container -->


<div class="pricing-cont">

  <h1 class="hdings">Pricing</h1>


  <div class="ps-cont">
    <div class="ps-cards">
      <div class="ps-card">
        <h2>£99</h2>
        <p class="title">Registration Fee</p>
        <p class="subtext">(Will be adjusted in the course fee.)</p>
      </div>
      <div class="ps-card">
        <h2>£1485.96</h2>
        <p class="title">Full Course Fee</p>
        <p class="subtext">(Valid after 30th May)</p>
      </div>
      <div class="ps-card">
        <h2>£1238.30</h2>
        <p class="title">Early Bird Price</p>
        <p class="subtext">(Valid till end of May)</p>
      </div>
    </div>
    <div class="image-section">
      <img src="assets/images/ps-sec-img.jpg" alt="Student and Teacher">
    </div>
  </div>

</div>



<!-- Course Info -->

<div class="course-cont">
  <h1 class="hdings">Course Structure – 105 Live Online Classes (1 Hour Each)</h1>

  <div class="course-container">
    <div class="course-left">
      <div class="class-box">28 Maths Classes</div>
      <div class="class-box">28 English Classes</div>
      <div class="class-box">14 Verbal Reasoning Classes</div>
      <div class="class-box">14 Non-verbal Reasoning</div>
      <div class="class-box">21 dedicated doubt clearing sessions</div>
      <div class="class-box note">
        Each class includes: Targeted study notes, Interactive teaching, In-class tests & Structured homework (tests & assignments)
      </div>
    </div>
    <div class="course-right">
      <img src="assets/images/course-poster.jpg" alt="Course Poster">
    </div>
  </div>
  

</div>



<!-- mock exam and review section -->


<div class="exam-sec">

  <h1 class="hdings">Mock Exams & Review</h1>

  <div class="offer-container">
    <div class="text-section">
      <h2>5 Full-Length Mock Tests</h2>
      <p>(Your choice of GL / CSSE / FSCE / SET)</p>
      <strong>Duration: 2 to 2.5 hours each</strong>
  
      <h2>5 Expert-Led Doubt-Clearing Sessions</h2>
      <p>Covers mock test reviews and class-related doubts (1 hour each)</p>
    </div>
    <div class="image-section">
      <img src="assets/images/writing-exam.jpg" alt="Student writing test">
    </div>
  </div>

</div>




<!-- Assesement Container -->

<div class="asm-cont">
  <h1 class="hdings">Assessment & Feedback</h1>

  <div class="analysis-container">
  <div class="image-side">
    <img src="assets/images/result-chart.jpg" alt="Result analysis charts" />
  </div>
  <div class="text-side">
    <div class="card">
      <strong>Result Analysis Report (RAR)</strong> – Performance insights
      (Rank, percentile, average, percentage etc) & detailed breakdown
    </div>
    <div class="card">
      <strong>Progress Review, Feedback & Personalised Consulting</strong>
    </div>
  </div>
</div>


</div>


<!-- PTM SECTION -->

<div class="ptm-section">
  <h1 class="hdings">Parent-Teacher Interaction</h1>

  <div class="ptm-container">
    <div class="ptm-content">
      <p>
        <span class="highlight">3 Parent-Teacher Meetings</span> (30 minutes each) to review progress and address any concerns.
      </p>
    </div>
    <div class="ptm-image">
      <img src="assets/images/ptm-sec.jpg" alt="Parent-Teacher Meeting">
    </div>
  </div>

</div>


<!-- Total Effor Time section -->


<div class="tet-section">

  <h1 class="hdings">Total Effort Time: <strong>121.5 Hours</strong> </h1>

  <div class="effort-time-container">
    <div class="effort-left">
      <img src="assets/images/clock-hand.jpg" alt="Clock in Hand">
    </div>
    <div class="effort-right">
      <div class="effort-box">105 Hours: Live Classes</div>
      <div class="effort-box">10 Hours: Mock Exams (5 × 2 hours)</div>
      <div class="effort-box">5 Hours: Mock Test Reviews (5 × 1 hour)</div>
      <div class="effort-box">1.5 Hours: Parent-Teacher Meetings (3 × 30 mins)</div>
    </div>
  </div>

</div>


<!-- LAST SECTION -->

<div class="last-sec">
  <h1 class="hdings">More About the Course</h1>

  <div class="course-info-section">
  
    <div class="info-container">
      <div class="info-content">
        <button class="learn-more-button" (click)="openExternalLink()">Learn More</button>
      </div>
      <div class="info-image">
        <img src="assets/images/learn-more.jpg" alt="Child studying at desk">
      </div>
    </div>
  </div>
</div>






